export default __webpack_public_path__ + "5e204581e0380d5139251d86581ced51.png";